/* ==========================================================
   component-hero-tabs.js
   Place in  assets/component-hero-tabs.js
   No dependencies. Handles:
   - tab switching (banner + collection swap)
   - carousel prev/next + swipe dots
   - AJAX add-to-cart via /cart/add.js
   ========================================================== */
(function () {
  'use strict';

  function initHero(root) {
    const tabs = root.querySelectorAll('[data-tab-index]');
    const panels = root.querySelectorAll('[data-tab-panel]');
    const autoplay = root.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
    let autoplayTimer = null;
    let activeIndex = 0;

    function activateTab(index) {
      activeIndex = index;
      tabs.forEach((tab) => {
        const isActive = parseInt(tab.dataset.tabIndex, 10) === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        const isActive = parseInt(panel.dataset.tabPanel, 10) === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) initCarousel(panel);
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activateTab(parseInt(tab.dataset.tabIndex, 10));
        resetAutoplay();
      });
    });

    function resetAutoplay() {
      if (!autoplay) return;
      clearInterval(autoplayTimer);
      autoplayTimer = setInterval(() => {
        activateTab((activeIndex + 1) % tabs.length);
      }, autoplaySpeed);
    }
    if (autoplay && tabs.length > 1) resetAutoplay();

    // ---- Carousel logic (per panel) ----
    const initializedCarousels = new WeakSet();

    function initCarousel(panel) {
      const carousel = panel.querySelector('[data-carousel]');
      if (!carousel || initializedCarousels.has(carousel)) return;
      initializedCarousels.add(carousel);

      const cards = carousel.querySelectorAll('[data-carousel-card]');
      const dotsWrap = panel.querySelector('[data-dots]');
      const prevBtn = panel.querySelector('[data-carousel-prev]');
      const nextBtn = panel.querySelector('[data-carousel-next]');

      if (dotsWrap && cards.length) {
        cards.forEach((_, i) => {
          const dot = document.createElement('span');
          dot.className = 'pc-hero__dot' + (i === 0 ? ' is-active' : '');
          dotsWrap.appendChild(dot);
        });
      }
      const dots = dotsWrap ? dotsWrap.querySelectorAll('.pc-hero__dot') : [];

      function cardWidth() {
        return cards.length ? cards[0].getBoundingClientRect().width + 14 : 0;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          carousel.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          carousel.scrollBy({ left: cardWidth(), behavior: 'smooth' });
        });
      }

      let scrollTimeout;
      carousel.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          if (!dots.length) return;
          const index = Math.round(carousel.scrollLeft / cardWidth());
          dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
        }, 80);
      });
    }

    // Initialize the first visible panel's carousel on load
    panels.forEach((panel) => {
      if (panel.classList.contains('is-active')) initCarousel(panel);
    });

    // ---- Add to cart (AJAX) ----
    root.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn || btn.disabled) return;

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then((res) => {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(() => {
          btn.textContent = 'Added ✓';
          btn.classList.add('is-added');
          // Let the theme know the cart changed, in case it has its own
          // cart drawer / bubble listening for this (works with most themes).
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = originalText;
            btn.classList.remove('is-added');
          }, 1800);
        })
        .catch(() => {
          btn.textContent = 'Try again';
          btn.disabled = false;
          setTimeout(() => { btn.textContent = originalText; }, 1800);
        });
    });
  }

  function boot() {
    document.querySelectorAll('.pc-hero').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init if Shopify theme editor swaps section HTML live
  document.addEventListener('shopify:section:load', function (e) {
    const hero = e.target.querySelector ? e.target.querySelector('.pc-hero') : null;
    if (hero) initHero(hero);
  });
})();
